import React from 'react';
import FittedImage from 'react-fitted-img';
import Helmet from 'react-helmet';
import Button from '../../components/Button/Button';
import StaticBanner from '../../components/StaticBanner/index';
import { ComponentTheme } from '../../definitions/components';
import companies from './companyData';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import './OurCompaniesDetail.css';
import isEmpty from 'lodash.isempty';

export default function OurCompaniesDetailRender() {
  const {
    name,
    links,
    tagline,
    content,
    banner_image: bannerImage,
    banner_image_mobile: bannerImageMobile,
    logo_image: logoImage
  } = companies[this.company];

  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const articleBannerMobile = !!bannerImageMobile ? bannerImageMobile : bannerImage;
        const articleBanner = !!isMobile || !!isTablet ? articleBannerMobile : bannerImage;

        return (
          <React.Fragment>
            <Helmet>
              {/* <title>{title}</title> */}
              {/* <link rel="canonical" href={`${Config.FRONT_END_URL}/${url}`} /> */}
              {/* <meta name="description" content={abstract} /> */}
            </Helmet>

            <div className={`page page--our-companies-details page--our-companies-${this.name}`}>
              <StaticBanner
                className='align-lower-left'
                title={name}
                subtitle={tagline}
                bannerImg={{
                  src: articleBanner,
                  srcSet: `${articleBanner} 240w`,
                  sizes: `"
                            (min-width: 320px) 420px,
                            (min-width: 768px) 380px,
                            (min-width: 1024px) 520px,
                            (min-width: 1200px) 640px
                          "`,
                  }}
              />

              <div className="content">
                <div className="container">
                  <div className="row">
                    <div className="company-attributes first-sm last-xs col-xs-12 col-sm-4">
                      {logoImage &&
                        <div className="image-container">
                          <FittedImage
                            className="fitted-img"
                            fit='contain'
                            decoding="async"
                            src={logoImage}
                            srcSet={`${logoImage} 240w`}
                            sizes="
                              (min-width: 320px) 420px,
                              (min-width: 768px) 380px,
                              (min-width: 1024px) 520px,
                              (min-width: 1200px) 640px
                            "
                            alt={name}
                          />
                        </div>}

                      <div className="actions">
                        {!isEmpty(links) &&
                          Object.keys(links).map((key) => {
                            return !!links[key] ?
                              <Button
                                key={`${name}-btn-${key}`}
                                classname={key}
                                text={`${key === 'web' ? 'Visit The Site' : ''}`}
                                link={links[key]}
                                target='_blank'
                                rel='noopener noreferrer'
                                theme={ComponentTheme.DARK_TRANSPARENT} />
                              :
                              false;
                          })
                        }
                      </div>
                    </div>

                    <div className="company-details first-xs last-sm col-xs-12 col-sm-8">
                      <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/OurCompaniesDetail/render.tsx